module.exports = __webpack_public_path__ + "assets/img/experts-2.d59ee01f.png";